import { useCallback, useEffect, useRef, useState } from 'react';
import { setTyping, subscribeTyping } from '@/services/chatService';

export function useTyping(requestId: string | null, uid: string | null) {
  const [typingUids, setTypingUids] = useState<string[]>([]);
  const timerRef = useRef<number | null>(null);

  useEffect(() => {
    if (!requestId) {
      setTypingUids([]);
      return;
    }
    return subscribeTyping(requestId, setTypingUids);
  }, [requestId]);

  const notifyTyping = useCallback(
    (isTyping: boolean) => {
      if (!requestId || !uid) return;
      void setTyping(requestId, uid, isTyping);
      if (timerRef.current) window.clearTimeout(timerRef.current);
      if (isTyping) {
        timerRef.current = window.setTimeout(() => {
          void setTyping(requestId, uid, false);
        }, 3000);
      }
    },
    [requestId, uid],
  );

  useEffect(() => {
    return () => {
      if (timerRef.current) window.clearTimeout(timerRef.current);
      if (requestId && uid) void setTyping(requestId, uid, false);
    };
  }, [requestId, uid]);

  const othersTyping = typingUids.filter((id) => id !== uid);

  return { othersTyping, notifyTyping };
}
